import e from "../managers/braze-instance.js";
export function subscribeToSdkAuthenticationFailures(i) {
  var r;
  if (e.X())
    return null === (r = e.Sr()) || void 0 === r
      ? void 0
      : r.subscribeToSdkAuthenticationFailures(i);
}
